import { Controller } from "stimulus"

// "Gebot ändern" on "Meine Artikel": shows the bid form in a dialog instead of the bid page.
export default class extends Controller {
  static targets = ["dialog"]
  static values = { open: Boolean }

  connect() {
    // Reopens the dialog after a failed change (?change=<item slug>).
    if (this.openValue) this.dialogTarget.showModal()
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  // A click on the backdrop lands on the dialog element itself.
  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
